// extracted by mini-css-extract-plugin
export default {"applicationsList":"contentapplicationslist_applicationsList__qJDbK","loading":"contentapplicationslist_loading__qkkNx"};